// /* eslint-disable indent */
/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const baobiaozhongxinRouter = {
	path: '/baobiaozhongxin',
	component: Layout,
	redirect: 'noRedirect',
	name: '报表',
	id: 1200000,
	meta: {
		title: '报表',
		icon: 'report',
		roles: [1200000]
	},
	children: [
		{
			path: 'summary',
			component: LayoutView,
			name: '营业收入',
			id: 1201000,
			meta: {
				title: '营业收入',
				roles: [1201000]
			},
			redirect: 'rechargesum',
			children: [
				{
					path: 'flowSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/flowSummary'
						),
					name: '营业收入明细',
					id: 1201100,
					meta: {
						title: '营业收入明细',
						roles: [1201100]
					}
				},
				{
					path: 'canteenSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/canteenSummary'
						),
					name: '营业收入汇总',
					id: 1201200,
					meta: {
						title: '营业收入汇总',
						roles: [1201200]
					}
				},
				// {
				// 	path: 'goodsSummary',
				// 	component: () =>
				// 		import(
				// 			/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/goodsSummary'
				// 		),
				// 	name: '菜品/商品销售明细',
				// 	id: 1201300,
				// 	meta: {
				// 		title: '菜品/商品销售明细',
				// 		roles: [1201300]
				// 	}
				// },
				{
					path: 'mealtimeSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/mealtimeSummary'
						),
					name: '按餐次收入汇总',
					id: 1201400,
					meta: {
						title: '按餐次收入汇总',
						roles: [1201400]
					}
				},
				{
					path: 'organizationSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/organizationSummary'
						),
					name: '按组织收入汇总',
					id: 1201500,
					meta: {
						title: '按组织收入汇总',
						roles: [1201500]
					}
				},
				{
					path: 'machineSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/machineSummary'
						),
					name: '按设备餐次收入汇总',
					id: 1201600,
					meta: {
						title: '按设备餐次收入汇总',
						roles: [1201600]
					}
				},
				{
					path: 'typeSummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/typeSummary'
						),
					name: '按人员类别收入汇总',
					id: 1201700,
					meta: {
						title: '按人员类别收入汇总',
						roles: [1201700]
					}
				},
				{
					path: 'paySummary',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/paySummary'
						),
					name: '按支付渠道收入汇总',
					id: 1201800,
					meta: {
						title: '按支付渠道收入汇总',
						roles: [1201800]
					}
				}
			]
		},

		{
			path: 'analysis',
			component: LayoutView,
			name: '经营分析',
			id: 1202000,
			meta: {
				title: '经营分析',
				roles: [1202000]
			},
			redirect: 'rechargesum',
			children: [
				// {
				// 	path: 'businessAnalysis',
				// 	component: () =>
				// 		import(
				// 		/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/businessAnalysis'
				// 		),
				// 	name: '营业分析',
				// 	id: 1202100,
				// 	meta: {
				// 		title: '营业分析',
				// 		roles: [1202100]
				// 	}
				// },
				{
					path: 'custAnalysis',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/custAnalysis'
						),
					name: '用户构成分析',
					id: 1202100,
					meta: {
						title: '用户构成分析',
						roles: [1202100]
					}
				},
				{
					path: 'evaluateAnalysis',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/evaluateAnalysis'
						),
					name: '食堂满意度统计',
					id: 1202200,
					meta: {
						title: '食堂满意度统计',
						roles: [1202200]
					}
				},
				{
					path: 'dishesSaleAnalysis',
					component: () =>
						import(
							/* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/statistics/dishesSaleAnalysis'
						),
					name: '菜品销售排行',
					id: 1202300,
					meta: {
						title: '菜品销售排行',
						roles: [1202300]
					}
				}
			]
		}

		//
		//
		//
		// {
		//   path: 'tradedetail',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "tradedetail" */ '@/leniuview/reportCenter/trade/trade'
		//     ),
		//   name: '交易流水',
		//   id: 1206000,
		//   meta: {
		//     title: '交易流水',
		//     roles: [1206000],
		//   },
		// },
		// {
		//   path: "food-waste",
		//   component: () =>
		//     import ( /* webpackChunkName: "tradedetail" */ "@/leniuview/reportCenter/foodWaste/foodwaste.vue"),
		//   name: "厨余报表",
		//   id: 1201200,
		//   meta: {
		//     title: "厨余报表",
		//     roles: [1201200]
		//   }
		// },
		// {
		//   path: "excel-error",
		//   component: () =>
		//     import ( /* webpackChunkName: "tradedetail" */ "@/leniuview/reportCenter/foodWaste/excelError.vue"),
		//   name: "厨余导入失败明细",
		// id: 1201200,
		// hidden:true,
		//   meta: {
		//     title: "厨余导入失败明细",
		//     roles: [1201200]
		//   }
		// },
		// {
		//   path: "accountsum",
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "accountsum" */ '@/leniuview/reportCenter/account/account'
		//     ),
		//   name: '账户余额汇总',
		//   id: 1207000,
		//   meta: {
		//     title: '账户余额汇总',
		//     roles: [1207000],
		//   },
		// },
		// {
		//   path: 'orgordnumdz',
		//   component: () => import('@/leniuview/reportCenter/tradesum/orgordnumdz'),
		//   name: '消费次数统计表',
		//   id: 1218000,
		//   meta: { title: '消费次数统计表', roles: [1218000] },
		// },
		// {
		//   path: 'rechargesum',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "rechargesum" */ '@/leniuview/reportCenter/rechargesum/layout'
		//     ),
		//   name: '充值汇总',
		//   id: 1201000,
		//   meta: {
		//     title: '充值汇总',
		//     roles: [1201000],
		//   },
		//   redirect: 'rechargesum',
		//   children: [
		//     {
		//       path: 'rechargesum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "rechargesum" */ '@/leniuview/reportCenter/rechargesum/rechargesum'
		//         ),
		//       name: '充值方式汇总',
		//       meta: {
		//         title: '充值方式汇总',
		//         roles: [1201100],
		//       },
		//     },
		//     // {
		//     //   path: "chongzhiPersonalSum",
		//     //   component: () =>
		//     //     import(/* webpackChunkName: "chongzhiPersonalSum" */"@/leniuview/accountCenter/chongzhisum/chongzhiPersonalSum"),
		//     //   name: "个人汇总",
		//     //   id: 810401,
		//     //   meta: { title: "personal.personalSum", roles: [810401] }
		//     // },
		//     {
		//       path: 'chongzhiDeptSum',
		//       component: () =>
		//         import ("@/leniuview/accountCenter/chongzhisum/chongzhiDeptSum"),
		//       name: "组织汇总",
		//       id: 810402,
		//       meta: {
		//         title: 'personal.deptSum',
		//         roles: [810402],
		//       },
		//     },
		//     {
		//       path: 'withdrawalSum',
		//       component: () =>
		//         import ("@/leniuview/accountCenter/withdrawalSum"),
		//       name: "取款汇总",
		//       id: 810600,
		//       meta: {
		//         title: 'personal.withdrawalSum',
		//         roles: [810600],
		//       },
		//     },
		//     // {
		//     //   path: "chongzhiPsnTypeSum",
		//     //   component: () =>
		//     //     import(/* webpackChunkName: "" */"@/leniuview/accountCenter/chongzhisum/chongzhiPsnTypeSum"),
		//     //   name: "人员类别汇总",
		//     //   id: 810403,
		//     //   meta: { title: "personal.psnTypeSum", roles: [810403] }
		//     // },
		//     {
		//       path: 'operatorCount',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "operatorCount" */ '@/leniuview/reportCenter/operatorCount/operatorCount'
		//         ),
		//       name: '操作员统计表',
		//       id: 1201010,
		//       meta: {
		//         title: 'baobiaozhongxin.operatorCount',
		//         roles: [1201010],
		//       },
		//       // dev: true
		//     },
		//   ],
		// },
		// {
		//   path: 'visitor',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "visitor" */ '@/leniuview/reportCenter/visitor/layout'
		//     ),
		//   name: '访客盘汇总',
		//   hidden: true,
		//   meta: {
		//     title: 'baobiaozhongxin.visitor',
		//     roles: [1216000],
		//   },
		//   redirect: 'visitor',
		//   children: [
		//     {
		//       path: 'visitorflowdetailpage',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "visitorflowdetailpage" */ '@/leniuview/reportCenter/visitor/visitorflowdetailpage'
		//         ),
		//       name: '访客盘消费流水表',
		//       id: 1216100,
		//       meta: {
		//         title: 'baobiaozhongxin.visitorflowdetailpage',
		//         roles: [1216100],
		//       },
		//     },
		//     {
		//       path: 'visitorsum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "visitorsum" */ '@/leniuview/reportCenter/visitor/visitorsum'
		//         ),
		//       name: '访客盘消费统计',
		//       id: 1216200,
		//       meta: {
		//         title: 'baobiaozhongxin.visitorsum',
		//         roles: [1216200],
		//       },
		//     },
		//     {
		//       path: 'deptpaymentsum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "deptpaymentsum" */ '@/leniuview/reportCenter/visitor/deptpaymentsum'
		//         ),
		//       name: '访客盘菜品销售汇总',
		//       id: 1216300,
		//       meta: {
		//         title: 'baobiaozhongxin.getRepVisitorMenuPage',
		//         roles: [1216300],
		//       },
		//     },
		//   ],
		// },
		// {
		//   path: 'duijiexiaofeiji',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "duijiexiaofeiji" */ '@/leniuview/reportCenter/duijiexiaofeiji/layout'
		//     ),
		//   name: '对接消费机',
		//   hidden: true,
		//   meta: {
		//     title: '对接消费机',
		//     roles: [1217000],
		//   },
		//   redirect: 'duijiexiaofeiji',
		//   children: [
		//     {
		//       path: 'liushui',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "duijiexiaofeiji" */ '@/leniuview/reportCenter/duijiexiaofeiji/liushui'
		//         ),
		//       name: '对接消费机流水表',
		//       id: 1217100,
		//       meta: {
		//         title: 'baobiaozhongxin.xfjliushui',
		//         roles: [1217100],
		//       },
		//     },
		//     {
		//       path: 'xiaofeisum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "xiaofeisum" */ '@/leniuview/reportCenter/duijiexiaofeiji/xiaofeisum'
		//         ),
		//       name: '对接消费机消费汇总',
		//       id: 1217200,
		//       meta: {
		//         title: 'baobiaozhongxin.xfjsum',
		//         roles: [1217200],
		//       },
		//     },
		//     {
		//       path: 'dishsum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "dishsum" */ '@/leniuview/reportCenter/duijiexiaofeiji/dishsum'
		//         ),
		//       name: '对接消费机菜品销售汇总',
		//       id: 1217300,
		//       meta: {
		//         title: 'baobiaozhongxin.xfjdishsum',
		//         roles: [1217300],
		//       },
		//     },
		//   ],
		// },
		// {
		//   path: 'tradesum',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "tradesum" */ '@/leniuview/reportCenter/tradesum/layout'
		//     ),
		//   name: '消费汇总',
		//   id: 1202000,
		//   meta: {
		//     title: 'baobiaozhongxin.tradesum',
		//     roles: [1202000],
		//   },
		//   redirect: 'tradesum',
		//   children: [
		//     {
		//       path: 'consumeSum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "consumeSum" */ '@/leniuview/reportCenter/tradesum/consumeSum'
		//         ),
		//       name: '营业汇总',
		//       id: 1202101,
		//       meta: {
		//         title: '营业汇总',
		//         roles: [1202101],
		//       },
		//     },
		//     {
		//       path: 'tradesumByCanteen',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByCanteen" */ '@/leniuview/reportCenter/tradesum/tradesumByCanteen'
		//         ),
		//       name: '食堂档口汇总',
		//       id: 1202100,
		//       meta: {
		//         title: 'baobiaozhongxin.tradesumByCanteen',
		//         roles: [1202100],
		//       },
		//     },
		//     {
		//       path: 'tradesumByDept',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByDept" */ '@/leniuview/reportCenter/tradesum/tradesumByDept'
		//         ),
		//       name: '组织汇总',
		//       id: 1202200,
		//       meta: {
		//         title: 'baobiaozhongxin.tradesumByDept',
		//         roles: [1202200],
		//       },
		//     },
		//     {
		//       path: 'tradesumByMachine',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByMachine" */ '@/leniuview/reportCenter/tradesum/tradesumByMachine'
		//         ),
		//       name: '设备汇总',
		//       id: 1202300,
		//       meta: {
		//         title: 'baobiaozhongxin.tradesumByMachine',
		//         roles: [1202300],
		//       },
		//     },
		//     {
		//       path: 'tradesumByPersonal',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByPersonal" */ '@/leniuview/reportCenter/tradesum/tradesumByPersonal'
		//         ),
		//       name: '个人消费汇总',
		//       id: 1202400,
		//       meta: {
		//         title: 'baobiaozhongxin.tradesumByPersonal',
		//         roles: [1202400],
		//       },
		//     },
		//     {
		//       path: 'tradesumByNuclearmode',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByNuclearmode" */ '@/leniuview/reportCenter/tradesum/tradesumByNuclearmode'
		//         ),
		//       name: '核身方式汇总',
		//       id: 1202500,
		//       meta: {
		//         title: '核身方式汇总',
		//         roles: [1202500],
		//       },
		//     },
		//     // {
		//     //   path: "tradesumByPsnType",
		//     //   component: () =>
		//     //     import("@/leniuview/reportCenter/tradesum/tradesumByPsnType"),
		//     //   name: "人员类别汇总",
		//     //   id: 1202600,
		//     //   meta: {
		//     //     title: "baobiaozhongxin.tradesumByPsnType",
		//     //     roles: [1202600]
		//     //   }
		//     // },
		//     // {
		//     //   path: "xiaofeisum",
		//     //   component: () =>
		//     //     import("@/leniuview/reportCenter/tradesum/xiaofeisum"),
		//     //   name: "消费金额汇总",
		//     //   id: 1221000,
		//     //   meta: {
		//     //     title: "消费金额汇总",
		//     //     roles: [1221000]
		//     //   }
		//     // },
		//     {
		//       path: 'tradesumByPayType',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "tradesumByPayType" */ '@/leniuview/reportCenter/tradesum/tradesumByPayType'
		//         ),
		//       name: '支付方式汇总',
		//       id: 1202800,
		//       meta: {
		//         title: '支付方式汇总',
		//         roles: [1202800],
		//       },
		//     },
		//     {
		//       path: "tradesumByPayTypeNew",
		//       component: () =>
		//         import ( /* webpackChunkName: "tradesumByPayType" */ "@/leniuview/reportCenter/tradesum/tradesumByPayType2"),
		//       name: "支付方式分餐次汇总",
		//       id: 1202810,
		//       // 1202810
		//       meta: {
		//         title: "支付方式分餐次汇总",
		//         roles: [1202810]
		//       }
		//     },
		//     {
		//       path: "sendbutie",
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "sendbutie" */ '@/leniuview/reportCenter/trade/sendbutie'
		//         ),
		//       name: '按就餐发放补贴',
		//       meta: {
		//         title: 'baobiaozhongxin.butiesum',
		//         roles: [1202700],
		//       },
		//       hidden: true,
		//     },
		//     // {
		//     //   path: "tradesumByOpt",
		//     //   component: () =>
		//     //     import("@/leniuview/reportCenter/tradesum/tradesumByOpt"),
		//     //   name: "操作员消费汇总",
		//     //   id: 1202900,
		//     //   meta: {
		//     //     title: "操作员消费汇总",
		//     //     roles: [1202900]
		//     //   }
		//     // },
		//     {
		//       path: 'caipinxiaoshouSum',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "caipinxiaoshouSum" */ '@/leniuview/reportCenter/caipinxiaoshou/caipinxiaoshouSum'
		//         ),
		//       name: '菜品销售汇总',
		//       id: 1209000,
		//       meta: {
		//         title: 'baobiaozhongxin.caipinxiaoshouSum',
		//         roles: [1209000],
		//       },
		//     },
		//   ],
		// },
		// // {
		// //   path: "consumerSubsidies",
		// //   component: () =>
		// //     import("@/leniuview/reportCenter/consumerSubsidies/layout"),
		// //   name: "消费补助",
		// //   id: 1218000,
		// //   meta: {
		// //     title: "消费补助",
		// //     roles: [1218000]
		// //   },
		// //   redirect: "consumerSubsidies",
		// //   children: [
		// //     {
		// //       path: "custordnumsub",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/consumerSubsidies/custordnumsub"),
		// //       name: "个人每餐消费次数补贴",
		// //       id: 1218200,
		// //       meta: { title: "个人每餐消费次数补贴", roles: [1218200] }
		// //     }
		// //   ]
		// // },
		// {
		//   path: 'statisticaltable',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "statisticaltable" */ '@/leniuview/reportCenter/statisticaltable/layout'
		//     ),
		//   name: '人员消费情况统计',
		//   hidden: true,
		//   meta: {
		//     title: 'baobiaozhongxin.statisticaltable',
		//     roles: [1203000],
		//   },
		//   redirect: 'statisticaltableByCaipin',
		//   children: [
		//     {
		//       path: 'statisticaltableByCaipin',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "statisticaltableByCaipin" */ '@/leniuview/reportCenter/statisticaltable/statisticaltableByCaipin'
		//         ),
		//       name: '菜品消费统计表',
		//       id: 1203100,
		//       meta: {
		//         title: 'baobiaozhongxin.statisticaltableByCaipin',
		//         roles: [1203100],
		//       },
		//     },
		//     {
		//       path: 'statisticaltableByCanci',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "statisticaltableByCanci" */ '@/leniuview/reportCenter/statisticaltable/statisticaltableByCanci'
		//         ),
		//       name: '就餐时段消费统计表',
		//       id: 1203200,
		//       meta: {
		//         title: 'baobiaozhongxin.statisticaltableByCanci',
		//         roles: [1203200],
		//       },
		//     },
		//     {
		//       path: 'statisticaltableByPerson',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "statisticaltableByPerson" */ '@/leniuview/reportCenter/statisticaltable/statisticaltableByPerson'
		//         ),
		//       name: '人员消费统计表',
		//       id: 1203300,
		//       meta: {
		//         title: 'baobiaozhongxin.statisticaltableByPerson',
		//         roles: [1203300],
		//       },
		//     },
		//   ],
		// },
		// {
		//   path: 'incomesum',
		//   component: () =>
		//     import(
		//       /* webpackChunkName: "incomesum" */ '@/leniuview/reportCenter/incomesum/layout'
		//     ),
		//   name: '收支汇总',
		//   id: 1204000,
		//   meta: {
		//     title: 'baobiaozhongxin.incomesum',
		//     roles: [1204000],
		//   },
		//   redirect: 'incomesum',
		//   children: [
		//     {
		//       path: 'deptpaymentsumsimple',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "deptpaymentsumsimple" */ '@/leniuview/reportCenter/incomesum/deptpaymentsumsimple'
		//         ),
		//       name: '组织收支汇总',
		//       id: 1204400,
		//       meta: {
		//         title: '组织收支汇总',
		//         roles: [1204400],
		//       },
		//     },
		//     {
		//       path: 'psnpaymentsumsimple',
		//       component: () =>
		//         import(
		//           /* webpackChunkName: "psnpaymentsumsimple" */ '@/leniuview/reportCenter/incomesum/psnpaymentsumsimple'
		//         ),
		//       name: '人员收支汇总',
		//       id: 1204500,
		//       meta: {
		//         title: '人员收支汇总',
		//         roles: [1204500],
		//       },
		//     },
		//     // {
		//     //   path: "old",
		//     //   name: "老版本报表",
		//     //   component: () => import("@/leniuview/reportCenter/incomesum/layout"),
		//     //   id: 1204100,
		//     //   meta: { title: "老版本报表", roles: [1204100] },
		//     //   children: [
		//     //     {
		//     //       path: "deptpaymentsum",
		//     //       component: () =>
		//     //         import("@/leniuview/reportCenter/incomesum/deptpaymentsum"),
		//     //       name: "按组织收支汇总",
		//     //       id: 1204101,
		//     //       meta: {
		//     //         title: "baobiaozhongxin.deptpaymentsum",
		//     //         roles: [1204101]
		//     //       }
		//     //     },
		//     //     {
		//     //       path: "datepaymentsum",
		//     //       component: () =>
		//     //         import("@/leniuview/reportCenter/incomesum/datepaymentsum"),
		//     //       name: "按日期收支汇总",
		//     //       id: 1204102,
		//     //       meta: {
		//     //         title: "baobiaozhongxin.datepaymentsum",
		//     //         roles: [1204102]
		//     //       }
		//     //     },
		//     //     {
		//     //       path: "psnpaymentsum",
		//     //       component: () =>
		//     //         import("@/leniuview/reportCenter/incomesum/psnpaymentsum"),
		//     //       name: "按人员收支汇总",
		//     //       id: 1204103,
		//     //       meta: { title: "baobiaozhongxin.psnpaymentsum", roles: [1204103] }
		//     //     }
		//     //   ]
		//     // }
		//   ],
		// },
		// // {
		// //   path: "peoplecardsum",
		// //   component: () => import("@/leniuview/reportCenter/peoplecardsum/layout"),
		// //   name: "人员办卡汇总",
		// //   id: 1205000,
		// //   meta: {
		// //     title: "baobiaozhongxin.peoplecardsum",
		// //     roles: [1205000]
		// //   },
		// //   redirect: "peoplecardsum",
		// //   children: [
		// //     {
		// //       path: "peoplechangecard",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/peoplecardsum/peoplechangecard"),
		// //       name: "人员换卡记录表",
		// //       id: 1205100,
		// //       meta: { title: "baobiaozhongxin.peoplechangecard", roles: [1205100] }
		// //     },
		// //     {
		// //       path: "deptcard",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/peoplecardsum/deptcard"),
		// //       name: "部门发卡汇总表",
		// //       id: 1205200,
		// //       meta: { title: "baobiaozhongxin.deptcard", roles: [1205200] }
		// //     }
		// //   ]
		// // },
		// // {
		// //   path: "jiucansum",
		// //   component: () => import("@/leniuview/reportCenter/jiucansum/layout"),
		// //   name: "就餐分析表",
		// //   id: 1215000,
		// //   meta: {
		// //     title: "baobiaozhongxin.jiucanqingkuang",
		// //     roles: [1215000]
		// //   },
		// //   redirect: "jiucansum",
		// //   children: [
		// //     {
		// //       path: "jiucanpeopledetail",
		// //       component: () => import("@/leniuview/reportCenter/jiucansum/index"),
		// //       name: "人员就餐明细",
		// //       id: 1215100,
		// //       meta: {
		// //         title: "baobiaozhongxin.jiucanpeopledetail",
		// //         roles: [1215100]
		// //       }
		// //     },
		// //     {
		// //       path: "salasAnalysis",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/jiucansum/salasAnalysis"),
		// //       name: "人员消费情况分析表",
		// //       id: 1215200,
		// //       meta: {
		// //         title: "baobiaozhongxin.salasAnalysis",
		// //         roles: [1215200]
		// //       }
		// //       // dev: true
		// //     },
		// //     {
		// //       path: "jiucanqingkuang",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/jiucansum/jiucanqingkuang"),
		// //       name: "人员就餐情况分析表",
		// //       id: 1215300,
		// //       meta: { title: "baobiaozhongxin.quanqijiucan", roles: [1215300] }
		// //     }
		// //   ]
		// // },
		// // {
		// //   path: 'shouzhisum',
		// //   component: () => import('@/leniuview/reportCenter/shouzhisum/index'),
		// //   name: '个人收支汇总',
		// //   meta: {
		// //     title: '个人收支汇总',
		// //     roles: [1003000]
		// //   }
		// // },
		// // {
		// //   path: "checkaccount",
		// //   component: () => import("@/leniuview/reportCenter/checkaccount"),
		// //   name: "对账",
		// //   meta: {
		// //     title: "对账",
		// //     redirect: "audit",
		// //     roles: [1],
		// //     flag: true
		// //   }
		// // },
		// // {
		// //   path: "checkPersonAccount",
		// //   component: () =>
		// //     import ( /* webpackChunkName: "checkPersonAccount" */ "@/leniuview/reportCenter/checkPersonAccount"),
		// //   name: "个人账户对账表",
		// //   meta: {
		// //     title: "个人账户对账表",
		// //     flag: true,
		// //     roles: [1]
		// //   }
		// // },
		// // {
		// //   path: "checkPersonFlow",
		// //   component: () =>
		// //     import ( /* webpackChunkName: "checkPersonFlow" */ "@/leniuview/reportCenter/checkPersonFlow"),
		// //   name: "个人收支明细表",
		// //   meta: {
		// //     title: "个人收支明细表",
		// //     flag: true,
		// //     roles: [1]
		// //   }
		// // },
		// // {
		// //   path: "historybal",
		// //   component: () => import("@/leniuview/reportCenter/trade/historybal"),
		// //   name: "余额变动情况表",
		// //   id: 1208000,
		// //   meta: {
		// //     title: "余额变动情况表",
		// //     roles: [1208000]
		// //   }
		// // },
		// // {
		// //   path: "caipinxiaoshouSum",
		// //   component: () =>
		// //     import("@/leniuview/reportCenter/caipinxiaoshou/caipinxiaoshouSum"),
		// //   name: "菜品销售汇总",
		// //   id: 1209000,
		// //   meta: {
		// //     title: "baobiaozhongxin.caipinxiaoshouSum",
		// //     roles: [1209000]
		// //   }
		// // },
		// // {
		// //   path: "shopxiaoshouSum",
		// //   component: () =>
		// //     import("@/leniuview/reportCenter/shopxiaoshousum/shopxiaoshouSum"),
		// //   name: "商城商品销售汇总",
		// //   id: 1218000,
		// //   meta: {
		// //     title: "商城商品销售汇总",
		// //     roles: [1218000]
		// //   }
		// // },
		// // {
		// //   path: 'caipinxiaoshou',
		// //   component: () => import('@/leniuview/reportCenter/caipinxiaoshou/layout'),
		// //   name: '菜品销售汇总分析',
		// //   meta: { title: '菜品销售汇总分析' , roles: [1004000]},
		// //   redirect: 'caipinxiaoshou',
		// //   children: [
		// //     {
		// //       path: 'caipinxiaoshouSum',
		// //       component: () => import('@/leniuview/reportCenter/caipinxiaoshou/caipinxiaoshouSum'),
		// //       name: '菜品销售汇总',
		// //       meta: { title: '菜品销售汇总' , roles: [1001000]},
		// //       // dev: true
		// //     },
		// //     // {
		// //     //   path: 'caipinPriceDetail',
		// //     //   component: () => import('@/leniuview/reportCenter/caipinxiaoshou/caipinPriceDetail'),
		// //     //   name: '菜品价格分析表',
		// //     //   meta: { title: '菜品价格分析表' },
		// //     //   // dev: true
		// //     // },
		// //     // {
		// //     //   path: 'caipinxiaoshouDetail',
		// //     //   component: () => import('@/leniuview/reportCenter/caipinxiaoshou/caipinxiaoshouDetail'),
		// //     //   name: '菜品销售分析',
		// //     //   meta: { title: '菜品销售分析' },
		// //     //   // dev: true
		// //     // },
		// //   ]
		// // },
		// // {
		// //   path: 'renyuancard',
		// //   component: () => import('@/leniuview/reportCenter/renyuancard/renyuancard'),
		// //   name: '人员卡务信息表',
		// //   meta: { title: '人员卡务信息表' },
		// //   dev: true
		// // },
		// {
		//   path: 'sysOperation',
		//   component: () =>
		//     import('@/leniuview/reportCenter/sysOperation/sysOperation'),
		//   name: '系统运行情况表',
		//   id: 1212000,
		//   meta: {
		//     title: 'baobiaozhongxin.sysOperation',
		//     roles: [1212000],
		//   },
		//   // dev: true
		// },
		// // {
		// //   path: "customreport",
		// //   component: () => import("@/leniuview/reportCenter/customreport/layout"),
		// //   name: "定制查询",
		// //   id: 1213000,
		// //   meta: {
		// //     title: "定制查询",
		// //     roles: [1213000]
		// //   },
		// //   redirect: "customreport",
		// //   children: [
		// //     // {
		// //     //   path: "dangkoudaifu",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/dangkoudaifu"),
		// //     //   name: "档口代付汇总",
		// //     //   id: 1213100,
		// //     //   meta: { title: "档口代付汇总", roles: [1213100] }
		// //     // },
		// //     // {
		// //     //   path: "shouzhi",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/shouzhi"),
		// //     //   name: "部门收支汇总",
		// //     //   id: 1213200,
		// //     //   meta: { title: "部门收支汇总", roles: [1213200] }
		// //     // },
		// //     // {
		// //     //   path: "personxiaofeisum",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/personxiaofeisum"),
		// //     //   name: "个人消费汇总",
		// //     //   id: 1213300,
		// //     //   meta: { title: "个人消费汇总", roles: [1213300] }
		// //     // },
		// //     // {
		// //     //   path: "deptxiaofeisum",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/deptxiaofeisum"),
		// //     //   name: "部门消费汇总",
		// //     //   id: 1213400,
		// //     //   meta: { title: "部门消费汇总", roles: [1213400] }
		// //     // },
		// //     // {
		// //     //   path: "orderdetail",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/orderdetail"),
		// //     //   name: "订单明细",
		// //     //   id: 1213500,
		// //     //   meta: { title: "订单明细", roles: [1213500] }
		// //     // },
		// //     // {
		// //     //   path: "ordersum",
		// //     //   component: () =>
		// //     //     import("@/leniuview/reportCenter/customreport/ordersum"),
		// //     //   name: "订单汇总",
		// //     //   id: 1213600,
		// //     //   meta: { title: "订单汇总", roles: [1213600] }
		// //     // },
		// //     {
		// //       path: "custmonthtradesum",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/customreport/custmonthtradesum"),
		// //       name: "个人每月补贴&充值消费明细",
		// //       id: 1213700,
		// //       meta: { title: "个人每月补贴&充值消费明细", roles: [1213700] }
		// //     },
		// //     {
		// //       path: "custmonthordsum",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/customreport/custmonthordsum"),
		// //       name: "个人月度总消费表",
		// //       id: 1213800,
		// //       meta: { title: "个人月度总消费表", roles: [1213800] }
		// //     },
		// //     {
		// //       path: "tradeinfo",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/customreport/tradeinfo"),
		// //       name: "每日消费明细表",
		// //       id: 1213900,
		// //       meta: { title: "每日消费明细表", roles: [1213900] }
		// //     }
		// //   ]
		// // },
		// // {
		// //   path: "shuikongsum",
		// //   component: () => import("@/leniuview/reportCenter/shuikongsum/layout"),
		// //   name: "水控查询",
		// //   id: 1214000,
		// //   meta: {
		// //     title: "baobiaozhongxin.shuikongsum",
		// //     roles: [1214000]
		// //   },
		// //   redirect: "shuikongsum",
		// //   children: [
		// //     {
		// //       path: "shuikongdetail",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/shuikongsum/shuikongdetail"),
		// //       name: "水控明细",
		// //       id: 1214100,
		// //       meta: { title: "baobiaozhongxin.shuikongdetail", roles: [1214100] }
		// //     },
		// //     {
		// //       path: "shuikonghuizong",
		// //       component: () =>
		// //         import("@/leniuview/reportCenter/shuikongsum/shuikonghuizong"),
		// //       name: "水控汇总",
		// //       id: 1214200,
		// //       meta: { title: "baobiaozhongxin.shuikonghuizong", roles: [1214200] }
		// //     }
		// //   ]
		// // }
	]
}

export default baobiaozhongxinRouter
